import { faArrowRightLong } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from 'cn';
import { useTranslations } from 'use-intl';

interface Props {
  className?: string;
}

const ProjectUsabilityResponseIframePlaceholder = ({ className }: Props) => {
  const t = useTranslations('Usability');

  return (
    <div
      data-test='usability-iframe-placeholder'
      className={cn(
        'flex size-full flex-col items-center justify-center gap-4 bg-gray-100',
        className
      )}
    >
      <div className='flex size-20 items-center justify-center rounded-full border border-gray-200 bg-white'>
        <FontAwesomeIcon
          icon={faArrowRightLong}
          className='text-3xl text-gray-600'
        />
      </div>
      <p className='text-center text-base/6 text-gray-600'>
        {t('placeholderInstructionLine1')}
        <br />
        {t('placeholderInstructionLine2')}
      </p>
    </div>
  );
};

export default ProjectUsabilityResponseIframePlaceholder;
